import utils from '../../../common/utils'
import QRCode from 'qrcode'

class certificationModalCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, $uibModal) {
        async function getQrCode(msg,type) {
            let param = {
                authorizeId: items1.authorizeId,
            }
            await httpRequest.post_getScanLoginQrCode(param).then((res) => {
               
                if (msg) {
                    logger[type](msg)
                }
                $scope.scanCodeId = res.data.value.scanCodeId
                let scanQrCodeContext = res.data.value.scanQrCodeContext
                QRCode.toDataURL(scanQrCodeContext).then((url) => {
                    $scope.srcBase64 = url
                    $scope.$apply()
                })
            })
        }
        let timer_1
        let timer_2
        async function getResult(params) {
            await httpRequest.post_queryNewQrCodeStatus({
                authorizeId:items1.authorizeId,
                attestationId:$scope.scanCodeId
            }).then(res=>{
                console.log(res.data.value)
                $scope.status = res.data.value.status
                if($scope.status==='0'){
                    //init('请重新扫码登录','logError') 
                    clearTimeout(timer_1)
                    clearTimeout(timer_2)
                    $scope.message =  res.data.value.message
                }else if($scope.status=='1'){
                    logger.logSuccess('扫码登录成功')
                    $uibModalInstance.dismiss()
                }else{
                    if(timer_2) clearTimeout(timer_2)
                    timer_2 = setTimeout(function(){
                        getResult()
                    },5000)
                }
            })
        }
        async function  init(msg,type='logSuccess') {
            await getQrCode(msg,type)
            if(timer_1)clearTimeout(timer_1)
            if(timer_2)clearTimeout(timer_2)
            //定时任务20秒后执行
            timer_1= setTimeout(function(){
                getResult()
            },5000)
        }
        init()
        $scope.refreshQrCode = function () {
            $scope.message =''
            init('二维码刷新成功')
        }
        $scope.ok = function () {
            $scope.queryQrCodeStatus()
        }
        $scope.cancel = function () {
            $uibModalInstance.dismiss()
        }
    }
}

certificationModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', '$uibModal']
export default certificationModalCtrl



// WEBPACK FOOTER //
// ./src/app/main/common/scanCodeLoginModalCtrl.js